import { render } from "./EditCost.vue?vue&type=template&id=78199db3"
import script from "./EditCost.vue?vue&type=script&lang=js"
export * from "./EditCost.vue?vue&type=script&lang=js"
script.render = render

export default script